<script>
import Layout from '../layout/Layout'
import Mixin from './mixin'

export default {
  name: 'ControleRgiMain',
  provide: function () {
    return {
      mainLayout: this
    }
  },
  mixins: [Mixin],
  components: {
    Layout
  },
  data () {
    return {
      activeMenu: 'gestao'
    }
  },
  computed: {
    menu () {
      return Menu
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
  },
  meta: {
    title: 'Controle de RGI',
    name: 'Controle de RGI'
  }
}
</script>

<template>
  <layout no-menu class="pessoa" no-title pad hfull>
    <router-view />
  </layout>
</template>

<style lang="stylus" src="./assets/default.styl"></style>
